"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackConfirmPhoneConfirmClick = trackConfirmPhoneConfirmClick;
exports.trackConfirmPhoneResendClick = trackConfirmPhoneResendClick;
exports.trackConfirmPhoneShown = trackConfirmPhoneShown;
exports.trackTwoFactorAttemptsExhaustedPopupOpen = trackTwoFactorAttemptsExhaustedPopupOpen;
exports.trackTwoFactorAttemptsExhaustedSupportClick = trackTwoFactorAttemptsExhaustedSupportClick;
exports.trackTwoFactorCannotConfirmClick = trackTwoFactorCannotConfirmClick;
exports.trackTwoFactorClose = trackTwoFactorClose;
exports.trackTwoFactorContinueClick = trackTwoFactorContinueClick;
exports.trackTwoFactorInvalid = trackTwoFactorInvalid;
exports.trackTwoFactorPhoneInputClick = trackTwoFactorPhoneInputClick;
exports.trackTwoFactorPopupOpen = trackTwoFactorPopupOpen;
exports.trackTwoFactorWhatForClick = trackTwoFactorWhatForClick;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _types = require("./types");
var _tracking = require("../../utils/tracking");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function trackConfirmPhoneShown(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackConfirmPhoneConfirmClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_click'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackConfirmPhoneResendClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_retry'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Открытие попапа двухфакторной авторизации
 */
function trackTwoFactorPopupOpen(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Open',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}reg_popup`
  });
}

/**
 * Открытие попапа двухфакторной авторизации
 */
function trackTwoFactorClose(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}close`
  });
}

/**
 * Открытие попапа после нескольких попыток ввода неправильного кода
 */
function trackTwoFactorAttemptsExhaustedPopupOpen(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}fatal`
  });
}
function trackTwoFactorInvalid(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}simple`
  });
}
function trackTwoFactorWhatForClick(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}what_for`
  });
}
function trackTwoFactorContinueClick(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}continue`
  });
}
function trackTwoFactorCannotConfirmClick(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}cant_confirm`
  });
}
function trackTwoFactorAttemptsExhaustedSupportClick(type) {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: `${type ? _types.EVENT_TWO_FACTOR_MAPPER[type] : ''}write_to_support`
  });
}
function trackTwoFactorPhoneInputClick() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: 'phone_input'
  });
}